const dataLayer = window.dataLayer || [];

const updateDataLayer = (data) => {
	dataLayer.push(data);
};

/**
 *
 * @param {string} interaction_type -  "account_login_cta_click" | "create_account_cta_click"
 * @param {string} link_text
 * @param {string} link_url
 * @param {string} site_section
 */

const trackUserAccountCTAClick = (interaction_type, link_text, link_url, site_section) => {
	updateDataLayer({
		event: interaction_type,
		link_text,
		link_url,
		site_section,
	});
};

export const trackAppliedFiltersCatalogs = (catalogsForm) => {
	if (catalogsForm) {
		const filtersChecked = catalogsForm.querySelectorAll('.m-checkbox__input:checked');

		if (filtersChecked.length === 0) {
			return false;
		}

		if (filtersChecked.length === 2) {
			let isDefaultTypeSelected = false;
			let isDefaultLanguageSelected = false;
			for (const filterChecked of filtersChecked) {
				if (filterChecked.name !== 'type' && filterChecked.name !== 'language') {
					break;
				}

				if (filterChecked.name === 'type') {
					if (filterChecked.value === 'Catalog') {
						isDefaultTypeSelected = true;
					}
				}

				if (filterChecked.name === 'language') {
					if (filterChecked.value === 'English') {
						isDefaultLanguageSelected = true;
					}
				}
			}

			if (isDefaultTypeSelected && isDefaultLanguageSelected) {
				return false;
			}
		}

		const catalogsFilters = [];
		filtersChecked.forEach((catalogFilter) => {
			catalogsFilters.push(catalogFilter.getAttribute('data-dl-filter'));
		});
		dataLayer.push({
			event: 'add_filter',
			search_type: 'catalog',
			filter: catalogsFilters,
		});
	}
};

export const trackCompareBearings = () => {
	dataLayer.push({
		event: 'compare',
		item: window._timken.compareBearingsData,
	});
};

const handleSearchClickAnalytics = (event) => {
	const interactionTypeMap = {
		parts: 'parts',
		catalog: 'catalogs & literature',
		recent: 'recently searched',
		suggestions: 'search suggestions',
	};
	const searchInputValue = document.querySelector('.probox input[type="search"]').value;
	const $targetEl = event.currentTarget;

	const $searchContainer = $targetEl.closest('[data-parts-results]');
	const { partResultsTotalCount, catalogResultsTotalCount, catalogsPreviewResultsCount, partsPreviewResultsCount } = getSearchResultsCounts($searchContainer);

	const targetText = $targetEl.innerText;
	const targetURL = $targetEl.getAttribute('href');
	const targetInteractionType = interactionTypeMap[ $targetEl.dataset.searchResultType ];

	trackSiteSearchInteractionClick(targetInteractionType, targetText, targetURL, searchInputValue, partResultsTotalCount, catalogResultsTotalCount, partsPreviewResultsCount, catalogsPreviewResultsCount);
};

const addSearchClickHandlers = ($searchContainer) => {
	const $resultsLinks = $searchContainer.querySelectorAll(
		'[data-search-section-recent] a,[data-search-section-parts] a, [data-search-section-catalog] a, [data-search-section-suggestions] a');
	$resultsLinks.forEach(($resultItemLink) => {
		$resultItemLink.addEventListener('click', handleSearchClickAnalytics);
	});
};

const trackGlobalSearch = () => {
	const aspMainContainer = document.querySelector('.asp_main_container');
	if (! aspMainContainer) {
		return;
	}

	aspMainContainer.addEventListener('asp_results_show', function(resultsDetails) {
		const searchResults = document.getElementsByClassName('js-search-results')[ 0 ];
		addSearchClickHandlers(searchResults);
		trackSearchSuccess(searchResults);
	});
};

const buildTotalSearchResults = (total_parts, total_catalog) => {
	const total_all_results = parseInt(total_parts) + parseInt(total_catalog);
	return `${ total_parts } | ${ total_catalog } | ${ total_all_results }`;
};

const buildTotalPreviewSearchCount = (total_part_previews, total_catalog_previews) => {
	const total_preview_results = parseInt(total_part_previews) + parseInt(total_catalog_previews);
	return `${ total_part_previews } | ${ total_catalog_previews } | ${ total_preview_results }`;
};

const successfulSearchCheck = (part_total, catalog_total) => {
	return parseInt(part_total) + parseInt(catalog_total) > 0;
};

/**
 *
 * @param {string} interaction_type       - "parts" | "catalogs & literature" | "recently searched" | "search suggestions"
 * @param {string} link_text
 * @param {string} link_url
 * @param {string} search_term
 * @param {string} total_parts
 * @param {string} total_catalog
 * @param {string} total_part_previews
 * @param {string} total_catalog_previews
 */
export const trackSiteSearchInteractionClick = (interaction_type, link_text, link_url, search_term, total_parts, total_catalog, total_part_previews, total_catalog_previews) => {
	updateDataLayer({
		event: 'site_search_interaction_click',
		interaction_type,
		link_text,
		link_url,
		num_of_results: buildTotalSearchResults(total_parts, total_catalog),
		number_of_results: buildTotalPreviewSearchCount(total_part_previews, total_catalog_previews),
		search_term,
		search_type: 'onsite - lookahead results',
		successful_search: successfulSearchCheck(total_parts, total_catalog),
	});
};

const getSearchResultsCounts = ($searchContainer) => {
	const partsPreviewResultsCount = $searchContainer ? Number($searchContainer.getAttribute('data-parts-results')) : 0;
	const catalogsPreviewResultsCount = $searchContainer ? Number($searchContainer.getAttribute('data-catalogs-results')) : 0;
	const $partResultsTotalEl = $searchContainer.querySelector('[data-search-section-parts-total]');
	const partResultsTotalCount = $partResultsTotalEl ? parseInt($partResultsTotalEl.dataset.searchSectionPartsTotal) : 0;
	const $catalogResultsTotalEl = $searchContainer.querySelector('[data-search-section-catalog-total]');
	const catalogResultsTotalCount = $catalogResultsTotalEl ? parseInt($catalogResultsTotalEl.dataset.searchSectionCatalogTotal) : 0;
	return {
		partResultsTotalCount,
		catalogResultsTotalCount,
		partsPreviewResultsCount,
		catalogsPreviewResultsCount,
	};
};

export const trackSearchSuccess = ($searchContainer) => {
	const { partResultsTotalCount, catalogResultsTotalCount, catalogsPreviewResultsCount, partsPreviewResultsCount } = getSearchResultsCounts($searchContainer);

	updateDataLayer({
		event: `${ successfulSearchCheck(partResultsTotalCount, catalogResultsTotalCount) ? 'successful_search' : 'unsuccessful_search' }`,
		num_of_results: buildTotalSearchResults(partResultsTotalCount, catalogResultsTotalCount),
		number_of_results: buildTotalPreviewSearchCount(partsPreviewResultsCount, catalogsPreviewResultsCount),
		search_type: 'onsite',
	});
};

const trackOffRampLink = () => {
	document.addEventListener('click', (event) => {
		const $target = event.target;

		const $link = $target.hasAttribute('data-link-click') ? $target : $target.closest('[data-link-click]');

		if ($link) {
			const text = $link.text?.trim();

			dataLayer.push({
				event: 'off_ramp_selection',
				off_ramp_link: text,
			});
		}
	});
};

export const trackPDPContentLink = () => {
	const $links = document.querySelectorAll('.t-parts-details__body a');

	$links.forEach((link) => {
		link.addEventListener('click', () => {
			const text = link.textContent?.trim();
			const url = link.getAttribute('href');

			dataLayer.push({
				event: 'eng_pdp_content_click',
				link_text: text,
				link_url: url,
			});
		});
	});
};

export const trackPDPDetailsHeadLink = () => {
	const $resultActions = document.querySelector('.t-parts-details__actions')?.querySelectorAll('.js-share-cta, .js-print-cta');

	if ($resultActions) {
		$resultActions.forEach((action) => {
			action.addEventListener('click', () => {
				const event = action.classList.contains('js-share-cta') ? 'pdp_email_results' : 'pdp_print';
				dataLayer.push({
					event,
				});
			});
		});
	}
};
export const trackHomepageContentLink = () => {
	const $containers = document.querySelectorAll(
		'.js-start-search-new, .js-start-search-saved, .js-popular-tools, .js-eng-tools',
	);

	$containers.forEach((section) => {
		section.addEventListener('click', (event) => {
			const { target, currentTarget } = event;
			const $link = target.matches('a') ? target : target.closest('a');
			const subheading = currentTarget.querySelector('h3:not(.d-none)')?.textContent;

			if ($link) {
				const text = $link.text?.trim();
				const url = $link.getAttribute('href');

				dataLayer.push({
					event: 'eng_homepage_content_click',
					subheading,
					link_text: text,
					link_url: url,
				});
			}
		});
	});
};

export const trackLandingPageLink = () => {
	const $links = document.querySelectorAll('article.page a, .sso-widget-resource-banner a');

	$links.forEach((link) => {
		link.addEventListener('click', () => {
			const text = link.textContent?.trim();
			const url = link.getAttribute('href');

			if (url === '#') {
				dataLayer.push({
					event: 'eng_content_click',
					link_text: text,
				});
			} else {
				dataLayer.push({
					event: 'eng_content_click',
					link_text: text,
					link_url: url,
				});
			}
		});
	});
};

export const trackBannerLink = () => {
	const topNavLinks = document.querySelectorAll('.m-header__utility-nav a');

	if (topNavLinks) {
		topNavLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const name = event.currentTarget.text;
				const url = event.currentTarget.getAttribute('href');

				dataLayer.push({
					event: 'top_navigation_ribbon_click',
					nav_link_name: name,
					link_url: url,
				});
			});
		});
	}
};

const trackSocialFlowEvent = () => {
	const socialLink = document.querySelectorAll('#menu-social a');

	if (socialLink) {
		socialLink.forEach((link) => {
			link.addEventListener('click', (event) => {
				const name = event.currentTarget.text;

				dataLayer.push({
					event: 'social_follow',
					social_network: name,
				});
			});
		});
	}
};

const trackEngineeringToolAction = () => {
	const $resultActions = document
		.querySelector('.js-engineering-tools-result-actions')
		?.querySelectorAll('.js-share-cta, .js-print-cta');

	if ($resultActions) {
		$resultActions.forEach((action) => {
			action.addEventListener('click', () => {
				const event = action.getAttribute('data-dl-event');
				const name = action.getAttribute('data-tool');
				const item = JSON.parse(action.getAttribute('data-bearing'));

				dataLayer.push({
					event,
					et_name: name,
					item,
				});
			});
		});
	}
};

const trackFindADistributorLink = () => {
	const findADistributorLinks = document.querySelectorAll('#find-a-distributor, #find-a-distributor-icon');

	if (findADistributorLinks) {
		findADistributorLinks.forEach((action) => {
			action.addEventListener('click', ( event ) => {
				const url = event.currentTarget.getAttribute('href');
				const link_text = event.currentTarget.ariaLabel ? event.currentTarget.ariaLabel : event.currentTarget.textContent?.trim();
				dataLayer.push({
					event: 'eng_find_a_distributor_link_click',
					link_url: url,
					link_text: link_text
				})
			});
		});
	}
}

const trackTopNavigationEvent = () => {
	const utilityAndPrimaryLinks = document.querySelectorAll(
		'#utility-menu a, #primary-menu > .menu-item:not(.menu-item-has-children) a',
	);

	if (utilityAndPrimaryLinks) {
		utilityAndPrimaryLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const name = event.currentTarget.text;
				dataLayer.push({
					event: 'top_navigation_click',
					nav_link_name: name,
				});
			});
		});
	}

	const submenuLinks = document.querySelectorAll('#primary-menu .menu-item-has-children .sub-menu a');

	if (submenuLinks) {
		submenuLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const name = event.currentTarget.text;
				const parent = event.currentTarget.closest('.menu-item-has-children').querySelector('a').text;
				dataLayer.push({
					event: 'top_navigation_click',
					nav_link_name: `${ parent }|${ name }`,
				});
			});
		});
	}

	const logoLink = document.querySelector('.m-header__logo a');
	if (logoLink) {
		logoLink.addEventListener('click', () => {
			dataLayer.push({
				event: 'top_navigation_click',
				nav_link_name: 'Timken logo',
			});
		});
	}

	const helpButtonLink = document.querySelector('.m-header__navigation-help-button');
	if (helpButtonLink) {
		helpButtonLink.addEventListener('click', (event) => {
			const name = event.currentTarget.text;
			dataLayer.push({
				event: 'top_navigation_click',
				nav_link_name: name.trim(),
			});
		});
	}
};

const trackFooterNavigationEvent = () => {
	const footerLinks = document.querySelectorAll('#menu-footer a');

	if (footerLinks) {
		footerLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const name = event.currentTarget.text;

				dataLayer.push({
					event: 'footer_navigation_click',
					nav_link_name: name,
				});
			});
		});
	}
};

const trackDownloadEvent = () => {
	document.addEventListener('click', (event) => {
		const isLiteratureLink = event.target.closest('.m-filtered-grid__entry-link--literature');
		if (isLiteratureLink) {
			const url = isLiteratureLink.getAttribute('href') ?? '';
			dataLayer.push({
				event: 'download_file',
				download_url: url,
			});
		}
	});
};

const trackHeroClickEvent = () => {
	const heroLinks = document.querySelectorAll('.js-home-banner a, .m-hero a');

	if (heroLinks) {
		heroLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const $targetEl = event.currentTarget;
				const name = $targetEl.innerText;
				const href = $targetEl.getAttribute('href');
				if (href.indexOf('register') > -1) {
					trackUserAccountCTAClick('create_account_cta_click', name, href, 'homepage hero banner');
				}

				dataLayer.push({
					event: 'hero_click',
					hero_details: name,
				});
			});
		});
	}
};

const trackAccountLoginEvent = () => {
	const loginLinks = document.querySelectorAll('.sso-widget__login-button');

	if (loginLinks) {
		loginLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const $targetEl = event.currentTarget;
				const name = $targetEl.innerText;
				const href = window?._timken?.accountUrl.replace('myaccount', 'login');

				trackUserAccountCTAClick('account_login_cta_click', name, href, 'header ribbon');
			})
		})
	}
}

const trackAccountRegisterEvent = () => {
	const registerLinks = document.querySelectorAll('.sso-widget__register-button');

	if (registerLinks) {
		registerLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const $targetEl = event.currentTarget;
				const name = $targetEl.innerText;
				const href = window?._timken?.accountUrl.replace('myaccount', 'register');

				trackUserAccountCTAClick('create_account_cta_click', name, href, 'header ribbon');
			})
		})
	}
}

export const trackHeroCarouselClick = (data) => {
	dataLayer.push({
		event: 'carousel_click',
		carousel_details: data.details,
		link_url: data.href,
		link_text: data.name,
	});
};

const trackCarouselClick = () => {
	const $sliderLink = document.querySelectorAll('.c-card-slider a');

	if ($sliderLink) {
		$sliderLink.forEach((link) => {
			link.addEventListener('click', () => {
				const name = link.text?.trim(),
					href = link.href?.trim(),
					carouselEl = link.closest('.c-card-slider'),
					slideEl = link.closest('.n2-ss-slide'),
					carouselName = carouselEl?.getElementsByTagName('h3')[ 0 ]?.outerText?.trim() || 'Carousel',
					slideName = slideEl?.querySelectorAll("[id^='n2-ss-']")[ 0 ]?.outerText?.trim() || 'Slide',
					slideNumber = slideEl?.dataset?.slidePublicId || '1';

				dataLayer.push({
					event: 'carousel_click',
					carousel_details: `${ carouselName }|${ slideName }|${ slideNumber }`,
					link_url: href,
					link_text: name,
				});
			});
		});
	}
};

export const trackAccordionClick = (accordionTitle) => {
	dataLayer.push({
		event: 'accordion_click',
		accordion_title: accordionTitle,
	});
};

const trackCompareViewDetailsEvent = () => {
	const $compareDetails = document.querySelectorAll('.js-compare-bearings-details');

	if ($compareDetails) {
		$compareDetails.forEach(($link) => {
			$link.addEventListener('click', () => {
				const data = JSON.parse($link.getAttribute('data-bearing'));
				const position = Number($link.getAttribute('data-position'));

				dataLayer.push({
					event: 'product_click',
					item: {
						item_id: data.marketplace_description || '',
						item_name: data.marketplace_description || '',
						item_brand: null,
						index: position,
						item_category: 'bearing',
						item_category2: data.bearing_type,
						item_category3: data.bearing_subtype,
						item_list_name: 'compare bearings',
					},
				});

				const url = $link.getAttribute('data-url');
				if (url) {
					window.open(url, '_blank', 'noopener,noreferrer');
				}
			});
		});
	}
};

const trackAuthStatus = () => {
	document.addEventListener('timken_sso_account_info_loaded', async (event) => {
		if (event.detail.accountInfo) {
			dataLayer.push({
				event: 'user_info',
				uid: event.detail.accountInfo.uid ?? '',
				h_id: event.detail.accountInfo.email ? await hashValue(event.detail.accountInfo.email) : '',
				authentication_status: 'authenticated',
				user_role: event.detail.accountInfo.user_role,
				company: event.detail.accountInfo.company,
			});
		} else {
			dataLayer.push({
				event: 'user_info',
				authentication_status: 'not authenticated',
			});
		}
	});
};

async function hashValue(value) {
	const utf8 = new TextEncoder().encode(value);
	const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const hashHex = hashArray
		.map((bytes) => bytes.toString(16).padStart(2, '0'))
		.join('');
	return hashHex;
}

document.addEventListener('DOMContentLoaded', () => {
	trackGlobalSearch();

	trackSocialFlowEvent();

	trackTopNavigationEvent();

	trackFooterNavigationEvent();

	trackDownloadEvent();

	trackHeroClickEvent();

	trackEngineeringToolAction();

	trackOffRampLink();

	trackPDPContentLink();

	trackPDPDetailsHeadLink();

	trackHomepageContentLink();

	trackLandingPageLink();

	trackBannerLink();

	trackCarouselClick();

	trackCompareViewDetailsEvent();

	trackAuthStatus();

	trackFindADistributorLink();

	trackAccountLoginEvent();

	trackAccountRegisterEvent();
});
